import {
  Directive,
  HostListener,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import * as rutHelpers from 'rut-helpers';

@Directive({
  selector: '[directiveFormatoNumeroDocumento]'
})
export class FormatearSerialDirective {
  @Output() public cambioElemento: EventEmitter<any>;
  @Input() public directiveFormatoNumeroDocumento: string;

  constructor() {
    this.cambioElemento = new EventEmitter();
  }

  @HostListener('input', ['$event']) onChange(event: Event) {
    const elementoHTML: HTMLInputElement = event.target as HTMLInputElement;
    const valorInicial = elementoHTML.value.toUpperCase();
    const formatoAntiguo = valorInicial.charAt(0) === 'A';
    const regexp = formatoAntiguo ? /[^0-9aA]*/g : /[^0-9A-Z]*/g;
    const maxLength = formatoAntiguo ? 10 : 11;

    // seteo elemento
    elementoHTML.maxLength = maxLength;
    elementoHTML.value = valorInicial.replace(regexp, '');
    if (valorInicial !== elementoHTML.value) {
      event.stopPropagation();
    }

    if (!formatoAntiguo) {
      elementoHTML.value = this.agregaCaracter(
        elementoHTML.value,
        +this.directiveFormatoNumeroDocumento
      );
    }
    this.cambioElemento.emit(elementoHTML.value.replace(regexp, ''));
  }

  public agregaCaracter = (valor: string, index: any): string => {
    let resultado = valor.slice(-index);
    for (let i = index; i < valor.length; i += index) {
      resultado = `${valor.slice(-index - i, -i)}.${resultado}`;
    }
    return resultado;
  };
}
